'use client';

import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './star-rating.scss';

type Props = Omit<ComponentPropsWithoutRef<'div'>, 'onChange'> & {
    value: number;
    onChange: (value: number) => void;
    max?: number;
    disabled?: boolean;
};
export const StarRating = ({ value, onChange, max = 5, disabled = false, className, ...props }: Props) => {
    const handleClick = (rating: number) => {
        if (!disabled) {
            onChange(rating);
        }
    };

    return (
        <div className={cn('star-rating', className)} {...props}>
            {Array.from({ length: max }, (_, index) => {
                const rating = index + 1;
                const isFilled = rating <= value;

                return (
                    <button
                        key={rating}
                        type="button"
                        className="star-rating__star"
                        onClick={() => handleClick(rating)}
                        disabled={disabled}
                        data-state={isFilled ? 'filled' : 'empty'}
                        aria-label={`Rate ${rating} out of ${max}`}
                        data-testid={`star-rating-star-${rating}`}
                    >
                        {isFilled ? <Icon name="star-fill" /> : <Icon name="star" />}
                    </button>
                );
            })}
        </div>
    );
};
